module.exports = __webpack_public_path__ + "img/fullwebpage.b1e018fb.svg";